import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { roleGroupings } from '../constants';

const listItems = (intl, value) => Object.values(roleGroupings).map((type) => ({
  key: `role_type_dropdown_item_${type}`,
  text: intl.formatMessage({ id: `roles.grouping.${type}` }),
  description: intl.formatMessage({ id: `roles.grouping.${type}.description` }),
  value: type,
  active: type === value,
}));

const RoleGroupingsDropdown = ({
  value,
  canEdit,
  onChange,
  disabled,
}) => {
  const intl = useIntl();
  if (!canEdit) {
    return (<FormattedMessage id={`role.grouping.${value}`} />);
  }

  return (
    <Dropdown
      id="role_groupings_dropdown"
      value={value}
      disabled={disabled}
      fluid
      selection
      options={listItems(intl, value)}
      onChange={onChange}
    />
  );
};

export default RoleGroupingsDropdown;
